
import { stampGet } from '@/api/jianianhua'
import HeaderDialog from './header-dialog'
import descStar from '@/assets/jfcj/desc_star.png'
import descBottom from '@/assets/jfcj/bottom_bg.png'
import descSuccess from '@/assets/jfcj/tc_scu.png'
import descFalied from '@/assets/jfcj/tc_fail.png'
import { getExam, getview, save, getstep, addstep, checkZj } from '@/api/jfhl.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import ScratchWrap from './scratch-wrap'
export default {
directives: {
TransferDom
},
components: {
XDialog,
HeaderDialog,
ScratchWrap
},
data () {
return {
showOpen: false,
showSuccess: false,
showFalied: false,
showQuestion: false,
desc_star: descStar,
desc_bottom: descBottom,
desc_success: descSuccess,
desc_falied: descFalied,
partyid: this.$route.params.partyid,
lotid: 0,
times: 1,
paperInfoid: '',
guanList: [
{
index: 1,
status: 2
},
{
index: 2,
status: 2
},
{
index: 3,
status: 2
},
{
index: 4,
status: 2
},
{
index: 5,
status: 2
}
],
examList: [],
useroption: [],
subjectid: [],
currentNum: '第一关',
currentGuan: 0,
currentStatus: '2', // 闯关失败
dialogText: '',
questionList: [],
isclick: false,
completedGuan: 0 
}
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
mounted () {
this.view()
},
created () { },
methods: {

view () {
getview({
id: this.partyid
}).then(res => {
this.paperInfoid = res.obj.paperid
this.lotid = res.obj.lotid
this.getstemp(res.obj.rulecode, res.obj.num)
checkZj({
partyid: this.partyid,
accountid: this.accountid,
lotid: this.lotid
}).then(data => {
if (data.obj.num === 1 && data.obj.isaward === 1) {
var _this = this
this.$vux.alert.show({
content: '今天已经中奖了，请明天再来~',
buttonText: '查看抽奖记录',
onHide () {
_this.record(2)
}
})
} else {
this.getstep(1)
}
})
})
},
getstemp (code, num) {
stampGet({
accountId: this.accountid,
ruleCode: code,
num: num
})
},
answer (index) {
if (index > this.currentGuan + 1) {
this.$vux.toast.text('您前面的关层还没有答题通过')
return false
}
this.getstep()
},
activeTitle (index) {
switch (index) {
case 0:
this.currentNum = '第一关'
break
case 1:
this.currentNum = '第二关'
break
case 2:
this.currentNum = '第三关'
break
case 3:
this.currentNum = '第四关'
break
case 4:
this.currentNum = '第五关'
break
}
return this.currentNum
},
getstep (isShow) {
getstep({
accountid: this.accountid,
partyid: this.partyid
}).then(res => {
this.currentGuan = res.obj.gknum
this.currentStatus = res.obj.succ
this.completedGuan = res.obj.num
if (isShow) {
this.getGuanList()
if (isShow === 1 && res.obj.gknum === 5) {
this.$router.push({ name: 'integralDraw9', params: { partyid: this.partyid } })
}
if (res.obj.num >= 3 && res.obj.gknum === 0) {
if (isShow === 3) {
return false
}
this.getLimtNum()
}
} else {
this.activeTitle(this.currentGuan)
this.getExam()
}
})
},
getLimtNum () {
var _this = this
this.$vux.alert.show({
content: '今天闯关次数已达上限',
buttonText: '回到首页',
onHide () {
_this.record(1)
}
})
},
getGuanList () {
this.guanList.forEach(item => {
if (item.index <= this.currentGuan && this.currentStatus === '1') {
item.status = 1
} else {
item.status = 2
}
})
},

getExam () {
getExam({
paperInfoid: this.paperInfoid,
openid: this.accountid
}).then(data => {
if (data.obj.ANSWERNUM <= 0) {
this.$vux.toast.text('您今天的一次答题机会已用完请明天再来')
return false
}
if (data.obj.SUBJECTLIST && data.obj.SUBJECTLIST.length > 0) {
this.examList = data.obj.SUBJECTLIST
this.useroption = []
this.subjectid = []
data.obj.SUBJECTLIST.forEach(element => {
this.subjectid.push(element.SUBJECTID)
})
this.showOpen = true
} else {
this.examList = []
this.subjectid = []
this.$vux.toast.text('答题库没有题')
return false
}
})
},

submit () {
if (this.isclick === false) {
this.isclick = true
if (this.useroption.length === this.examList.length) {
save({
paperInfoid: this.paperInfoid,
subjectid: this.subjectid.join(';'),
useroption: this.useroption.join(';'),
openid: this.accountid
}).then(data => {
this.addstep(data.obj.ISTRUE)
if (data.obj.ISTRUE === 2) {
let wt = data.obj.ERRORLIST.length
this.dialogText = '答对' + (this.examList.length - wt) + '题，答错' + wt + '题'
this.questionList = data.obj.ERRORLIST
setTimeout(() => {
this.isclick = false
}, 1000)
}
})
} else {
this.$set(this.useroption, this.useroption.length)
this.$vux.toast.text('有题没回答，请选择答案')
setTimeout(() => {
this.isclick = false
}, 1000)
return false
}
}
},
addstep (item) {
addstep({
partyid: this.partyid,
accountid: this.accountid,
gknum: this.currentGuan + 1,
p1: item,
lotid: this.lotid
}).then(data => {
this.showOpen = false
setTimeout(() => {
this.isclick = false
}, 1000)
if (this.completedGuan >= 2) {
this.getstep(3)
} else {
this.getstep(2)
}
if (item === 1) {
this.showSuccess = true
} else {
this.showFalied = true
}
})
},

proceed () {
this.showSuccess = false
this.getstep()
},

scratch () {
this.showSuccess = false
this.$router.push({ name: 'integralDraw9', params: { partyid: this.partyid } })
},

agin () {
this.showFalied = false
if (this.completedGuan >= 3) {
this.getLimtNum()
} else {
this.getstep()
}
},

errorQuestion () {
this.showFalied = false
this.showQuestion = true
},

close () {
this.showQuestion = false
if (this.completedGuan >= 3) {
this.getLimtNum()
} else {
this.getstep()
}
},
record (item) {
this.$router.push({ name: 'integralDraw7', params: { partyid: this.partyid, type: item } })
}
}
}
